import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Link } from 'react-router-dom';

function NavigationBar() {
    return (
        <Navbar expand="lg" className="bg-body-tertiary">
            <Container>
                <Navbar.Brand as={Link} to="/">
                    <img
                        src="/logo.png"
                        height="45"
                        className="d-inline-block align-top p-0"
                        alt="Cresco logo"
                    />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="mx-auto">
                        <Nav.Link className="mx-3" as={Link} to="/">Home</Nav.Link>
                        <Nav.Link className="mx-3" as={Link} to="/services">Services</Nav.Link>
                        <Nav.Link className="mx-3" as={Link} to="/cybersecurity">Cybersecurity</Nav.Link>
                        <Nav.Link className="mx-3" as={Link} to="/partners">Partners</Nav.Link>
                        <Nav.Link className="mx-3" as={Link} to="/about">About Us</Nav.Link>
                        <Nav.Link
                            as={Link}
                            to="/contactus"
                            className="btn btn-dark text-white px-4 rounded-1 mx-3"
                            style={{ backgroundColor: '#212529' }}
                            active={false}
                        >
                            Contact Us
                        </Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default NavigationBar; 